import $ from 'jquery';

const Video = (el) => {
    $(el).on('click', function(e) {
        $(e.currentTarget).hide();
        $(e.currentTarget).prev('.js-image').fadeOut('slow');
        const iframeContainer = $(e.currentTarget).parent().find('.iframe-container');
        iframeContainer.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    });
}

export default Video;
